














































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GExamDetailProgressChart from '@/views/GExamDetail/GExamDetailProgressChart.vue';
import { ExamineeStudentProgress } from '@/models/evalSetting/evaluator-student-progress';

@Component({
  name: 'GExamDetailProgressOverallCharts',
  components: { GExamDetailProgressChart },
  computed: {},
  methods: {},
})
export default class GExamDetailProgressAllCharts extends Vue {
  mounted() {}

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get colorTypeRed(): GEnum.ColorType {
    return GEnum.ColorType.Red;
  }

  get examineeCount(): number {
    return evalSettingDetailModule.examineeStudentProgresses.length;
  }

  get statusCompletedCount(): number {
    return evalSettingDetailModule.examineeStudentProgresses.filter((progress: ExamineeStudentProgress) => progress.isStatusCompleted).length;
  }

  get selfCompletedCount(): number {
    return evalSettingDetailModule.examineeStudentProgresses.filter((progress: ExamineeStudentProgress) => progress.isSelfProgressCompleted).length;
  }

  get giftCompletedCount(): number {
    return evalSettingDetailModule.examineeStudentProgresses.filter((progress: ExamineeStudentProgress) => progress.isGiftProgressCompleted).length;
  }

  get iatCompletedCount(): number {
    return evalSettingDetailModule.examineeStudentProgresses.filter((progress: ExamineeStudentProgress) => progress.isIatProgressCompleted).length;
  }

  get freeWordSkillCompletedCount(): number {
    return evalSettingDetailModule.examineeStudentProgresses.filter((progress: ExamineeStudentProgress) => progress.isFreeWordSkillProgressCompleted).length;
  }

  get trendCompletedCount(): number {
    console.log(evalSettingDetailModule.examineeStudentProgresses);
    return evalSettingDetailModule.examineeStudentProgresses.filter((progress: ExamineeStudentProgress) => progress.isTrendProgressCompleted).length;
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic) ||
           this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademicReadOnly);
  }
}
